import { inject, Injectable } from '@angular/core';
import { HttpMainService } from '../../http-main.service';
import { ListModel, ListRequestModel, ProfileResponseModel } from '@itb-monorepo/models';
import { Observable, of } from 'rxjs';
import {ReviewRequestModel} from "@itb-monorepo/models";
import { removeEmptyFields } from '@itb-monorepo/helper';
import { AuthService } from '../../utility-services/auth.service';


@Injectable()
export class SupporterProfileService {
  private _HttpMainService = inject(HttpMainService);
  private authService = inject(AuthService);
  baseUrl = '/member/';


  getList(params?: ListRequestModel): Observable<ListModel<ProfileResponseModel>> {
    if (!this.authService.hasAccess('profiles:L'))
      return of()
    return this._HttpMainService.get(`${this.baseUrl}v1/profiles`, removeEmptyFields(params));
   }

    get(userId: string): Observable<ProfileResponseModel> {
      if (!this.authService.hasAccess('profiles:R'))
        return of()
      return this._HttpMainService.get(this.baseUrl + "v1/profiles/" + userId);
    }
    review(userId: string, model: ReviewRequestModel): Observable<ProfileResponseModel> {
      if (!this.authService.hasAccess('profiles:S'))
        return of()
      return this._HttpMainService.patch(this.baseUrl + "v1/profiles/" + userId, model);
    }
    getFile(userId: string): Observable<any> {
      if (!this.authService.hasAccess('profiles:R'))
        return of()
      return this._HttpMainService.getFile(this.baseUrl + "v1/profiles/" + userId + '/documents/single');
    }

}
